module.exports = __webpack_public_path__ + "img/title4.7f73cf60.png";